import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';



import { UtilService } from './util-service';
import { GestaoPcaService } from './gestao-pca-service';

/*
  Generated class for the PlanoAcaoService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class PlanoAcaoService {

  constructor(http: HttpClient,
     private gestaoPcaService: GestaoPcaService,
    private utilService: UtilService) {
  }

  public obterPlanosAcoes(idQuestaoResposta): Observable<any> {
    let urlObtencaoDados: string = "questao/obterPlanoAcao?anoExercicio=" + this.gestaoPcaService.getPCA().dsAnoexercicio + "&idQuestao=" + idQuestaoResposta + "&idJurisdicionado=" + 4;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarPlanoAcao(jsonObjeto): Observable<any> {
    let urlObtencaoDados: string = "ocorrencia/obterPlanoAcao?idPca=";
    return this.utilService.postJSON(urlObtencaoDados, jsonObjeto);
  }

}



// WEBPACK FOOTER //
// ./src/providers/plano-acao-service.ts